import React from 'react'
import {
  Edit,
  SimpleForm,
  TextInput,
  RadioButtonGroupInput,
  minLength,
  SelectInput,
} from 'react-admin'

import { DEFAULT_API_ADMIN } from '@/constants'
import { getChainId } from '@lib'
import useFetch from '@lib/useFetch'

const validatePassword = [minLength(6)]

export default props => {
  const [{ data }] = useFetch({
    url: `${DEFAULT_API_ADMIN}/places`,
    initialState: { data: [] },
  })

  const getChoices = () =>
    data
      .filter(item => item.chainId === getChainId())
      .map(({ id, name }) => ({ id, name }))

  return (
    <Edit {...props} title="Editar usuário">
      <SimpleForm>
        <SelectInput
          label="Parceiro ou Posto"
          source="placeId"
          choices={data ? getChoices() : []}
        />
        <TextInput source="name" label="Nome" />
        <TextInput source="login" label="Login" />
        <TextInput
          source="password"
          label="Senha"
          validate={validatePassword}
        />
        <RadioButtonGroupInput
          label="Tipo de usuário"
          source="role"
          choices={[
            { id: 'manager', name: 'Parceiro gerencial' },
            { id: 'cashier', name: 'Parceiro operador' },
          ]}
        />
      </SimpleForm>
    </Edit>
  )
}
